import React from "react";
import { useNavigate } from "react-router-dom";

function Footer() {
    const navigator = useNavigate();
  return (
  <footer className="footer-wrapper">
    <div className="footer-inner">
      <div className="footer-left eskort-me">
        <p onClick={() => navigator("/exhibitions")}>About</p>
        <p onClick={() => navigator("/exhibitions")}>Contact</p>
      </div>

      <div className="footer-right">
        <div
          className="h2head eskort-bd"
          onClick={() => navigator("/")}
        >
          m(o)m
        </div>
      </div>
    </div>

    <p className="footer-bottom-text eskort-me">
      A critical spatial practice cultivating shared responsibility and
      collective imagination in art and architecture
    </p>
  </footer>
);

}

export default Footer;
